import { Component } from 'react'

import * as h from 'h'

import { ShareButtons } from 'components/SocialMedia'

import styles from './styles.scss'

export default class SocialPane extends Component {
  render () {
    return h.aside(h.ca(styles.socialPane),
      h.h(ShareButtons, {col: true, url: this.props.url, text: this.props.text}))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/Popout/SocialPane.js